<template>
  <div :style="{'background-image':'url(' + background + ')'}" class="imageTypeFolder">
    <p class="imageTypeFolder-title">{{title}}</p>
  </div>
</template>

<script>
export default {
  name: "ImageTypeFolder",
  props:["background","title"]

}
</script>

<style scoped>

.imageTypeFolder{
  position:relative;
  width:308px;
  height:100px;
  border:1px solid #ffffff;
  border-radius:3px;
  background-size:cover;
  background-position: center;
  cursor:pointer;
}

.imageTypeFolder-title{
  margin-left:20px;
  line-height:100px;
  font-size:16px;
  color:#ffffff;
  font-weight:bold;
  text-shadow: -1px 1px 0 #000, 1px 1px 0 #000, 1px -1px 0 #000,-1px -1px 0 #000;
}

</style>